import styled from 'styled-components';

const ReportModalWrapper = styled('div')`
  display: flex;
  flex-direction: column;
`;

const ReportLinkWrapper = styled('div')`
  display: flex;
  align-items: center;
  width: 100%;
  margin-top: 12px;
`;

const Title = styled('p')`
  font-size: 18px;
  line-height: 38px;
  color: #002f3f;
  outline: 0;
  margin: 0;
`;
const SubTitle = styled('p')`
  font-size: 16px;
  color: #595959;
  margin: 10px 0 5px;
`;

export { ReportModalWrapper, ReportLinkWrapper, Title, SubTitle };
